import { startTransition } from "react";

export type AppRoute =
  | {
      page:
        | "home"
        | "guide"
        | "privacy"
        | "terms"
        | "support"
        | "guilds"
        | "admin"
        | "admin-audit"
        | "admin-operations"
        | "not-found";
    }
  | {
      page:
        | "guild-overview"
        | "guild-settings"
        | "guild-access"
        | "guild-instructions"
        | "guild-identity"
        | "guild-operations"
        | "guild-sources"
        | "guild-ownership"
        | "guild-billing"
        | "guild-wowaudit"
        | "admin-guild";
      guildId: string;
    };

const guildRoute =
  /^\/guilds\/([^/]+)\/(overview|settings|access|instructions|identity|operations|sources|ownership|billing|wowaudit)$/;
const adminGuildRoute = /^\/admin\/guilds\/([^/]+)$/;

export function parseRoute(pathname: string): AppRoute {
  if (pathname === "/") return { page: "home" };
  if (pathname === "/guide") return { page: "guide" };
  if (pathname === "/privacy") return { page: "privacy" };
  if (pathname === "/terms") return { page: "terms" };
  if (pathname === "/support") return { page: "support" };
  if (pathname === "/guilds") return { page: "guilds" };
  if (pathname === "/admin") return { page: "admin" };
  if (pathname === "/admin/audit") return { page: "admin-audit" };
  if (pathname === "/admin/operations") return { page: "admin-operations" };

  const guildMatch = guildRoute.exec(pathname);
  if (guildMatch?.[1] && guildMatch[2]) {
    return {
      page: `guild-${guildMatch[2]}` as Extract<
        AppRoute,
        { guildId: string }
      >["page"],
      guildId: decodeURIComponent(guildMatch[1]),
    };
  }

  const adminMatch = adminGuildRoute.exec(pathname);
  if (adminMatch?.[1]) {
    return {
      page: "admin-guild",
      guildId: decodeURIComponent(adminMatch[1]),
    };
  }
  return { page: "not-found" };
}

export function navigate(
  href: string,
  setPathname: (pathname: string) => void,
) {
  const url = new URL(href, window.location.href);
  if (url.origin !== window.location.origin) {
    window.location.assign(url);
    return;
  }
  window.history.pushState(null, "", `${url.pathname}${url.search}${url.hash}`);
  startTransition(() => {
    setPathname(url.pathname);
  });
}

export function isModifiedNavigation(
  event: React.MouseEvent<HTMLAnchorElement>,
) {
  return (
    event.button !== 0 ||
    event.metaKey ||
    event.ctrlKey ||
    event.shiftKey ||
    event.altKey
  );
}
